import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 15h14v2H5z",
  opacity: ".3"
})), 'HorizontalSplitTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HorizontalSplitTwoTone.js
// module id = 4159
// module chunks = 2